/* @flow */

import React from 'react';
import { graphql } from 'react-apollo';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import type { OperationComponent } from 'react-apollo';

import { getUser } from '../../modules/session/getters';
import { switchLocale } from '../../modules/locale/actions';
import { locale } from '../../modules/locale/getters';

import { dismissFlashMessage } from '../../modules/profile/actions';
import { showFlashMessage } from '../../modules/profile/getters';

import profileQuery from './index.gql';

import Layout from './layouts/index';

type Props = {
  currentUser: Object,
  locale: string,
  switchLocale: Function,
  showFlashMessage: boolean,
  dismissFlashMessage: Function,
  match: {
    params: { userPath: string }
  }
};

const withStore: Function = connect(
  (state) => ({
    currentUser: getUser(state),
    locale: locale(state),
    showFlashMessage: showFlashMessage(state)
  }),
  {
    switchLocale: (locale: string) => switchLocale(locale),
    dismissFlashMessage: () => dismissFlashMessage()
  }
);

const withGraphqlQuery: OperationComponent<ProfileQuery> = graphql(profileQuery, {
  options: (props: Object) => {
    const userPath = props.match.params.userPath;
    const slug = userPath.substring(userPath.lastIndexOf('-') + 1);

    if (slug.length === 24) { // id, not slug
      return { variables: { id: slug }};
    }

    return { variables: { slug }};
  }
});

const Profile = (props: Props) => {
  const ProfileWithData = withGraphqlQuery(Layout);
  return <main>
    <Helmet><meta name="robots" content="noindex" /></Helmet>
    <ProfileWithData {...props} />
  </main>;
};

export default injectIntl(withStore(Profile));



// WEBPACK FOOTER //
// ./src/routes/profile/index.js